import React from 'react';
import { CircleAlertIcon, CircleCheckIcon, MapPinIcon } from 'lucide-react';
import type { RoadMapHeaderData } from '../../types/disclosure';
interface RoadMapHeaderProps {
  data: RoadMapHeaderData;
}
interface FactProps {
  label: string;
  value: string;
}
function Fact({
  label,
  value
}: FactProps) {
  return <div className="min-w-0" data-id="element-50" data-mp="2n2seid38c05a">
      <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400" data-id="element-51" data-mp="2n2k36pmr92w7">{label}</p>
      <p className="truncate text-[13px] font-medium text-slate-900" data-id="element-52" data-mp="31qwpeuw1j7di">{value}</p>
    </div>;
}
export function RoadMapHeader({
  data
}: RoadMapHeaderProps) {
  const isRequested = data.disclosureStatus === 'Requested';
  const allClear = data.outstandingItems === 0;
  return <header className="rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm" data-id="element-53" data-mp="36t5l3z0asnjb">
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3" data-id="element-54" data-mp="1ggg3owdgxfgc">
        <div className="min-w-0" data-id="element-55" data-mp="1cebatzuugmur">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-blue-700" data-id="element-56" data-mp="1cfe248w2wrb7">Road Map</p>
          <div className="flex flex-wrap items-baseline gap-x-2.5" data-id="element-57" data-mp="1xtwovqfowr7x">
            <h1 className="truncate text-lg font-semibold leading-7 text-slate-900" data-id="element-58" data-mp="22qn3safrdgrr">{data.borrowerName}</h1>
            <span className="text-sm tabular-nums text-slate-500" data-id="element-59" data-mp="27pgfbxbhixpa">Loan #{data.loanNumber}</span>
            <span className="inline-flex items-center gap-1 text-sm text-slate-500" data-id="element-60" data-mp="2ci9l8oiowc2y">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-61" data-mp="2hgudo1rp9rgu" />
              {data.propertyStreet}, {data.propertyState}
            </span>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-1.5" data-id="element-62" data-mp="2qgzhk1xoq7q9">
          <span className={['inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset', isRequested ? 'bg-emerald-50 text-emerald-800 ring-emerald-200' : 'bg-amber-50 text-amber-800 ring-amber-200'].join(' ')} data-id="element-63" data-mp="2qhisuzstxxvb">
            <CircleCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-64" data-mp="t0tqykqtu886" />
            Disclosure {data.disclosureStatus}
          </span>
          <span className={['inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset', allClear ? 'bg-slate-100 text-slate-700 ring-slate-200' : 'bg-amber-50 text-amber-800 ring-amber-200'].join(' ')} data-id="element-65" data-mp="p1324mkv226a">
            {allClear ? <CircleCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="17zffkkit1y7o" /> : <CircleAlertIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-67" data-mp="1lqk70zc0rk6x" />}
            {allClear ? 'Checklist complete' : `${data.outstandingItems}/${data.totalItems} outstanding`}
          </span>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2 border-t border-slate-100 pt-2.5 sm:grid-cols-3 lg:grid-cols-5" data-id="element-68" data-mp="1voq7dci6gi9o">
        <Fact label="Loan Purpose" value={data.loanPurpose} data-id="element-69" data-mp="1qnampljwwdrt" />
        <Fact label="Loan Officer" value={data.loanOfficer} data-id="element-70" data-mp="2ac8h4palk32y" />
        <Fact label="Lender" value={data.lender} data-id="element-71" data-mp="2ec8t83a8426u" />
        <Fact label="Est. Closing" value={data.madisonECD} data-id="element-72" data-mp="2ebz5kmcni74b" />
        <Fact label="Requested" value={data.disclosuresRequestedDate} data-id="element-73" data-mp="20diwwpv8a6jj" />
      </div>
    </header>;
}